import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import Vuex from 'vuex';
import { icon, latLng } from "leaflet";
import "leaflet.icon.glyph/Leaflet.Icon.Glyph";
import Nav from './components/nav/Main'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import i18n from './plugins/i18n';
import sample from './sample.json';
import sampleTerms from './sample_terms.json';

Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false // disable development warning
Vue.prototype.$mmconfig = window.mmconfig

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

// Leaflet Icon defaults
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.use(Vuex);
Vue.use(VueClipboard);

// test if a map item should be filtered or not
function filter(state, marker, filters) {
  if (!filters) return marker
  var year_start = parseInt(marker.date_start)
  var year_end = parseInt(marker.date_end)

  console.info(filters)

  return ((year_start >= filters.range[0] && year_start <= filters.range[1])
    || (year_end >= filters.range[0] && year_end <= filters.range[1])
    || (year_start <= filters.range[0] && year_end >= filters.range[1])) &&
    ((!filters.affiliation || filters.affiliation.length < 1) || (filters.affiliation && marker.meta.geistliche_zugehorigkeit !== undefined && marker.meta.geistliche_zugehorigkeit.length != 0 && filters.affiliation.some(c => marker.meta.geistliche_zugehorigkeit.includes(c))));
  //return true
  /*return (year >= filters.range[0] && year <= filters.range[1] && 
    typesToString(filters.type).includes(marker.type) && 
    (filters.category === undefined || filters.category.length == 0 ||
      (marker.category !== undefined && marker.category.length != 0 && filters.category.some(c => marker.category.some(m => state.categories[c].name == m.name)))));
    */}

function createPost(post) {
  var result = {
    id: post.ID,
    type: "monastery",
    date_start: post.meta.zeitraum_start,
    date_end: post.meta.zeitraum_ende,
    user: {
      id: post.post_author,
      username: post.display_name,
    },
    location: {
      latlng: {
        lat: post.location.latitude,
        lng: post.location.longitude
      },
    },
    meta: {
      grundungsdatum_typ: post.meta.grundungsdatum_typ,
      grundungsdatum: post.meta.grundungsdatum,
      grundungsdatum_text: post.meta.grundungsdatum_text,
      aufhebungsdatum_typ: post.meta.aufhebungsdatum_typ,
      aufhebungsdatum: post.meta.aufhebungsdatum,
      aufhebungsdatum_text: post.meta.aufhebungsdatum_text,
      geistliche_zugehorigkeit: post.meta.geistliche_zugehorigkeit,
      ortslage: post.meta.ortslage,
      ordensbezirk: post.meta.ordensbezirk,
    },
    title: post.post_title,
    permalink: post.permalink,
    description: post.meta.map_beschreibung,
    category: post.category,
    tags: post.tags,
    draggable: false,
    visible: true,
    bookmark: false,
  }

  result.media = {
    thumbnail: {
      url: post.attachment_url,
      width: 150,
      height: 150
    },
    standard_resolution: {
      url: post.attachment_url,
      width: 800,
      height: 600
    }
  }

  result.icon = icon.glyph({
    prefix: 'mdi',
    glyph: 'church',
    glyphSize: '17px',
    // Size of the glyph, in CSS units
    glyphAnchor: [0, -7],
  })

  return result;
}

export const store = new Vuex.Store({
  state: {
    map: null,            // map reference
    cluster: null,        // marker cluster reference
    user: null,           // user object
    markers: [],          // marker objects
    categories: [],       // categories
    affiliations: [],       // categories
    currentMarker: null,  // current marker object
    nav: false,           // toggle navbar
    sidenav: false,       // toggle sidebar
    currentNav: Nav,      // current navbar component
    snackbar: {
      active: false,
      content: '',
      color: '',
    },
  },
  mutations: {
    sidenav(state, val) {
      state.sidenav = val
    },
    nav(state, val) {
      state.nav = val
    },
    currentMarker(state, val) {
      state.currentMarker = val
    },
    updateData(state, val) {
      console.log("update data")
      val = val.map(post => {
        return createPost(post);
      });
      var ids = new Set(state.markers.map(d => d.id));
      state.markers = [...state.markers, ...val.filter(d => !ids.has(d.id))];
      if (val.length === 1) state.currentMarker = val[0];
    },
    updateCategories(state, val) {
      state.categories = val;
    },
    updateAffiliations(state, val) {
      state.affiliations = val; //[...new Set(state.markers.map(marker => marker.meta.geistliche_zugehorigkeit).flat(1))].sort();
    },
    updateMessage(state, msg) {
      // close eventually open snackbar
      state.snackbar.active = false;
      // open new snackbar
      setTimeout(() => {
        state.snackbar.content = msg.content;
        state.snackbar.color = msg.color;
        state.snackbar.active = true;
      }, 250)
    },
    SET_USER(state, user) {
      state.user = user
    },
  },
  actions: {
    login({ commit }, payload) {
      commit('SET_USER', payload)
    },
    logout({ commit }) {
      commit('SET_USER', null)
    },
    validate({ state }) {
      return axios({
        url: `${window.mmconfig.siteUri}/wp-json/jwt-auth/v1/token/validate`,
        method: 'post',
        headers: {
          'Authorization': `Bearer ${state.user.token}`
        }
      })
    },
    loadItem({
      commit
    }, slug) {
      return new Promise((resolve) => {
        axios.get(`${window.mmconfig.siteUri}${window.mmconfig.rest_ns}/item/${slug}`).then((response) => {
          commit('updateData', [response.data])
          resolve()
        }).catch((e) => {
          console.error("Loading item failed.")
          console.error(e)
        })
      });

    },
    loadData({
      commit
    }, bbox) {
      axios.get(`${window.mmconfig.siteUri}${window.mmconfig.rest_ns}/all?bbox=${bbox.left},${bbox.bottom},${bbox.right},${bbox.top}`).then((response) => {
        commit('updateData', response.data)
      }).catch((e) => {
        console.error("Loading items failed.")
        console.error(e)
        console.info("Loading sample data.")
        commit('updateData', sample)
      })
    },
    loadCategories({
      commit
    }) {
      axios.get(`${window.mmconfig.siteUri}${window.mmconfig.rest_ns}/categories`).then((response) => {
        commit('updateCategories', response.data)
      }).catch((e) => {
        console.error("Loading categories failed.")
        console.error(e)
      })
    },
    loadAffiliations({
      commit
    }) {
      axios.get(`${window.mmconfig.siteUri}${window.mmconfig.rest_ns}/meta_terms`).then((response) => {
        commit('updateAffiliations', response.data)
      }).catch((e) => {
        console.error("Loading categories failed.")
        console.error(e)
        console.info("Loading sample terms.")
        commit('updateAffiliations', sampleTerms)
      })
    },
    message({
      commit
    }, msg) {
      commit('updateMessage', msg)
    },
  },
  getters: {
    visibleMarkers: state => (filters) => {
      return state.markers.filter(marker => marker.visible && filter(state, marker, filters))
    },
    bookmarkMarkers: state => (filters) => {
      return state.markers.filter(marker => marker.bookmark && filter(state, marker, filters))
    },
    viewportMarkers: state => (filters) => {
      if (state.map === null) {
        return []
      } else {
        try {
          return state.markers.filter(
            marker => state.map.getBounds().contains(latLng(marker.location.latlng)) &&
              filter(state, marker, filters))
        } catch (err) {
          return []
        }
      }
    },
  },
});

export const eventBus = new Vue(); // event bus

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#media-map')
